import * as types from './types';

const initialState = {
  bumexFeatures: new Map(),
  bumexFeaturesError: new Map(),
  bumexFeaturesLoading: new Map(),
  bumexFeaturesBulkError: false,
  bumexFeaturesBulkLoading: false
};

const proccessBumexFeatures = (payload, bumexFeaturesRequested) => {
  const bumexFeaturesObtained = new Map();
  // PROCESO LAS BUMEX FEATURES QUE NO DEVOLVIERON NADA DEL BACKEND
  const payloadKeys = payload.map(p => p.keyfeature);
  const bfsWithoutValue = bumexFeaturesRequested.filter(bf => !payloadKeys.includes(bf));
  // eslint-disable-next-line no-unused-expressions
  bfsWithoutValue?.forEach(bf => {
    bumexFeaturesObtained.set(bf, false);
  });
  // PROCESO LOS VALORES OBTENIDOS DE LA BASE
  // eslint-disable-next-line no-unused-expressions
  payload?.forEach(d => {
    bumexFeaturesObtained.set(d.keyfeature, !!d.habilitado);
  });
  return bumexFeaturesObtained;
};

const getBFStatus = bf => {
  if (!bf[0]) return false;
  return !!bf[0].habilitado;
};

function bumexFeatureReducer(state = initialState, action) {
  switch (action.type) {
    // Eliminar post implementacion
    case types.GET_BUMEX_FEATURE:
      return {
        ...state,
        bumexFeaturesLoading: state.bumexFeaturesLoading.set(action.meta.keyFeature, true),
        bumexFeaturesError: state.bumexFeaturesError.set(action.meta.keyFeature, false)
      };

    case types.GET_BUMEX_FEATURE_COMPLETED:
      return {
        ...state,
        bumexFeaturesLoading: state.bumexFeaturesLoading.set(action.meta.keyFeature, false),
        bumexFeatures: state.bumexFeatures.set(action.meta.keyFeature, getBFStatus(action.payload))
      };

    case types.GET_BUMEX_FEATURE_FAILED:
      return {
        ...state,
        bumexFeaturesLoading: state.bumexFeaturesLoading.set(action.meta.keyFeature, false),
        bumexFeaturesError: state.bumexFeaturesError.set(action.meta.keyFeature, true)
      };

    case types.GET_BUMEX_FEATURE_BULK:
      return {
        ...state,
        bumexFeaturesBulkLoading: true,
        bumexFeaturesBulkError: false
      };

    case types.GET_BUMEX_FEATURE_BULK_COMPLETED:
      return {
        ...state,
        bumexFeaturesBulkLoading: false,
        bumexFeatures: proccessBumexFeatures(action.payload, action.meta.keyFeatures)
      };

    case types.GET_BUMEX_FEATURE_BULK_FAILED:
      return {
        ...state,
        bumexFeaturesBulkLoading: false,
        bumexFeaturesBulkError: true
      };

    default:
      return state;
  }
}

export default bumexFeatureReducer;
